import api from './api';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';

export type SystemPromptGroup = 'analysis' | 'recognition' | 'calculation';

export interface SystemPromptAuthor {
  id: number;
  email: string | null;
}

/** Запис журналу змін промпту (окрема таблиця на бекенді, без ліміту), новіші першими. */
export interface SystemPromptVersion {
  id: number;
  /** null - скинуто до стандартного тексту. */
  text: string | null;
  /** null - давня версія без дати. */
  updatedAt: string | null;
  updatedBy: SystemPromptAuthor | null;
}

/** Системний промпт (реєстр бекенду `SYSTEM_PROMPTS`, 2026-09-30). */
export interface SystemPromptView {
  key: string;
  /** false - лише системний: показується для розуміння, не редагується. */
  editable: boolean;
  title: string;
  description: string;
  group: SystemPromptGroup;
  placeholders: { name: string; description: string }[];
  /** Захищена частина (шаблон з коду) і місце вставки редагованого тексту. */
  systemTemplate: string;
  insertMarker: string | null;
  text: string;
  defaultText: string;
  isCustom: boolean;
  updatedAt: string | null;
  updatedBy: SystemPromptAuthor | null;
}

export const systemPromptsService = {
  async list(): Promise<SystemPromptView[]> {
    const response = await api.get<ApiResponse<SystemPromptView[]>>('/admin/system-prompts');
    return unwrapApiResponse<SystemPromptView[]>(response) ?? [];
  },
  /** Журнал змін - окремим запитом, лише коли його відкривають. */
  async history(key: string): Promise<SystemPromptVersion[]> {
    const response = await api.get<ApiResponse<SystemPromptVersion[]>>(`/admin/system-prompts/${key}/history`);
    return unwrapApiResponse<SystemPromptVersion[]>(response) ?? [];
  },
  async save(key: string, text: string): Promise<SystemPromptView> {
    const response = await api.put<ApiResponse<SystemPromptView>>(`/admin/system-prompts/${key}`, { text });
    return unwrapApiResponse<SystemPromptView>(response);
  },
  async reset(key: string): Promise<SystemPromptView> {
    const response = await api.delete<ApiResponse<SystemPromptView>>(`/admin/system-prompts/${key}`);
    return unwrapApiResponse<SystemPromptView>(response);
  },
};
